import { TAXI_QUOTE_BRANDREF } from "../../../../config/config";
import { SCHEME_IMAGES } from "../../../../config/insurers";
import useBuyStore from "../../../buy/store/BuyStore";
import useQuoteStore from "../../store/QuoteStore";
import { getSchemeImage } from "../../../../shared/utils/schemeImages";
import { LuCheck, LuCircleHelp } from "react-icons/lu";
import Button from "../../../../shared/components/Button";
import TqPanelExcessReduction from "./TqPanelExcessReduction";
import { getQuoteExcessLabel } from "../../utils/quoteDisplayData";

const TqPanelCard = ({
  quoteDisplay,
  register,
  errors,
  watch,
  setValue,
  onClick,
  onOpen,
  setSelectedSchemeTableId,
  openExplanationModal,
  setSelectedCardIndex, // <-- receive as prop
  setSelectedCard, // <-- use this instead of setSelectedCardQuote
  STATE,
  trigger,
}) => {
  const {
    quote,
    index,
    companyName,
    schemeTableId,
    excessReduction,
    financeOption,
    annualPrice,
    cardExcesses = [],
    configRows = [],
    uninsuredDriver,
  } = quoteDisplay;
  const { setObject } = useBuyStore();
  const brandRef = TAXI_QUOTE_BRANDREF;

  const riskObjectId = useQuoteStore.getState().quote?.risk?.riskObjectId;

  const handleBuyClick = () => {
    setSelectedCardIndex(index);
    setSelectedCard(quote);
    setValue("isSelected", index);
    setValue("companyName", quote.companyName);
    setValue("pricePerYear", quote.pricePerYear);
    setValue("SelectedSchemeTableId", quote.schemeTableId);
    setSelectedSchemeTableId && setSelectedSchemeTableId(schemeTableId);
    onClick();

    // Create the request body
    const panelMemberReqBody = {
      RiskObjectId: riskObjectId,
      RiskObjectHistoryId: "1",
      BrandRef: brandRef,
      PreSelectedQuoteAddons: [],
      SelectedSchemeTableId: quote.schemeTableId || "",
      UseSessionData: true,
    };

    const documentsRequestBody = {
      brandRef,
      RiskObjectId: riskObjectId,
      RiskObjectHistoryId: 1,
      documentTagStage: "Quote",
      documentTagCategory: "PreSaleQuoteDocuments",
    };

    // Store it in BuyStore
    setObject("recommendationsData", null);
    setObject("panelMemberReqBody", panelMemberReqBody);
    setObject("documentsRequestBody", documentsRequestBody);
    setValue("panelMemberReqBody", panelMemberReqBody);

    if (!STATE.memberRetry) {
      STATE.setIspolicyModal(true);
    }

    if (STATE.memberRetry) {
      STATE.setActionOnTqPanel("QuoteSelected");
    }

    if (errors.companyName) {
      trigger("companyName");
    }
  };

  return (
    <div className="tw-my-4 tw-hidden tw-overflow-hidden tw-rounded-dis-card tw-border tw-border-solid tw-border-dis-border tw-bg-white tw-text-base tw-text-dis-text-2 max-[1023px]:tw-flex max-[1023px]:tw-flex-col last:tw-mb-0">
      <div className="tw-flex tw-flex-col tw-gap-4 tw-p-4">
        <div className="tw-flex tw-items-center tw-justify-between tw-gap-3">
          <input
            id="companyName"
            label="companyName"
            type="text"
            placeholder="e.g M50 3YJ"
            className="tw-hidden"
            {...register("companyName", { required: "Required" })}
            errors={errors.companyName}
            watch={watch("companyName")}
          />
          <input
            id="pricePerYear"
            label="pricePerYear"
            type="text"
            placeholder="e.g M50 3YJ"
            className="tw-hidden"
            {...register("pricePerYear", { required: "Required" })}
            errors={errors.pricePerYear}
            watch={watch("pricePerYear")}
          />
          <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
            {getSchemeImage(quote.schemeTableId)}
            {!SCHEME_IMAGES[quote.schemeTableId] && (
              <span className="tw-text-base tw-font-semibold tw-text-dis-navy">
                {companyName}
              </span>
            )}
          </div>
          <div className="tw-flex tw-shrink-0 tw-flex-col tw-items-end tw-text-right">
            <span className="tw-text-dis-small tw-text-dis-text-muted">
              Annual price
            </span>
            <span className="tw-text-2xl tw-font-bold tw-leading-tight tw-text-dis-navy sm:tw-text-3xl">
              £
              {Number(annualPrice).toLocaleString("en-GB", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </div>
        </div>

        {financeOption && (
          <section
            className="tw-rounded-lg tw-bg-dis-info-panel tw-p-4"
            aria-label="Monthly installments"
          >
            <h2 className="tw-mb-2 tw-mt-0 tw-text-base tw-font-semibold tw-text-dis-navy">
              Monthly installments
            </h2>
            <div className="tw-flex tw-flex-col">
              <div className="tw-flex tw-justify-between tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-dis-divider tw-py-2">
                <span>Deposit</span>
                <span>£{financeOption.deposit}</span>
              </div>
              <div className="tw-flex tw-justify-between tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-dis-divider tw-py-2">
                <span>Monthly 9x</span>
                <span>£{financeOption.installmentAmount}</span>
              </div>
              <div className="tw-flex tw-justify-between tw-py-2 tw-font-semibold tw-text-dis-navy">
                <span>Total</span>
                <span>
                  £
                  {financeOption.totalAmountToPayByCustomer.toLocaleString(
                    "en-GB",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  )}
                </span>
              </div>
            </div>
            <p className="tw-m-0 tw-pt-1 tw-text-dis-small tw-leading-[1.5] tw-text-dis-text-muted">
              Paying by finance will cost you £
              {quote?.paymentOptions?.[0]?.serviceCharge?.toFixed(2)} more.
            </p>
          </section>
        )}

        <section aria-label="Policy excesses">
          <div className="tw-mb-1 tw-flex tw-items-center tw-justify-between tw-gap-2">
            <h2 className="tw-m-0 tw-text-base tw-font-semibold tw-text-dis-navy">
              Policy excesses
            </h2>
            <button
              type="button"
              onClick={() => openExplanationModal("Additional Excesses", quote)}
              className="tw-inline-flex tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-dis-text-muted hover:tw-text-dis-deep-blue"
              aria-label="Additional excess information"
            >
              <LuCircleHelp className="tw-h-4 tw-w-4" aria-hidden="true" />
            </button>
          </div>
          <div className="tw-flex tw-flex-col">
            {cardExcesses.map((excess, excessIndex) => (
              <div
                className={`tw-flex tw-justify-between tw-gap-3 tw-py-3 ${
                  excessIndex < cardExcesses.length - 1 || configRows.length
                    ? "tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-dis-divider"
                    : ""
                }`}
                key={excess.excessShortName + excess.excessAmount}
              >
                <span>{getQuoteExcessLabel(excess, quote.schemeTableId)}</span>
                <span className="tw-shrink-0 tw-font-semibold tw-text-dis-navy">
                  £{excess.excessAmount}
                </span>
              </div>
            ))}
            {configRows.map(({ config, lines, hasValue }, configIndex) => (
              <div
                className={`tw-flex tw-justify-between tw-gap-3 tw-py-3 ${
                  configIndex < configRows.length - 1
                    ? "tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-dis-divider"
                    : ""
                }`}
                key={config.code}
              >
                <span>{config.label}</span>
                <span className="tw-shrink-0 tw-font-semibold tw-text-dis-navy">
                  {hasValue
                    ? lines.map((line) => line.panelItemLine).join(", ")
                    : "£0"}
                </span>
              </div>
            ))}
          </div>
        </section>

        {uninsuredDriver && (
          <div className="tw-flex tw-items-center tw-justify-between tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-dis-divider tw-pt-3">
            <span className="tw-inline-flex tw-items-center tw-gap-1">
              Uninsured Driver
              <button
                type="button"
                onClick={() => openExplanationModal("Uninsured Driver", quote)}
                className="tw-inline-flex tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-dis-text-muted hover:tw-text-dis-deep-blue"
                aria-label="Uninsured driver information"
              >
                <LuCircleHelp className="tw-h-4 tw-w-4" aria-hidden="true" />
              </button>
            </span>
            {uninsuredDriver.insurerIncludesFeature ? (
              <LuCheck
                className="tw-h-4 tw-w-4 tw-text-dis-success"
                strokeWidth={3}
                aria-label="Included"
              />
            ) : (
              <span aria-label="Not included">&#10006;</span>
            )}
          </div>
        )}

        <div className="tw-grid tw-grid-cols-2 tw-gap-3">
          <Button
            type="button"
            variant="softQuote"
            size="small"
            fullWidth
            className="tw-whitespace-normal tw-text-center"
            onClick={() => onOpen(quote)}
          >
            Quote Details
          </Button>
          <Button
            type="button"
            variant="main"
            size="small"
            fullWidth
            className="tw-whitespace-normal tw-text-center"
            onClick={handleBuyClick}
          >
            Select Quote
          </Button>
        </div>
      </div>

      {excessReduction && (
        <TqPanelExcessReduction
          text={excessReduction}
          className="tw-flex tw-min-h-10 tw-w-full tw-items-center tw-gap-3 tw-bg-dis-deep-blue tw-px-4 tw-py-3 tw-text-dis-small tw-leading-[1.4] tw-text-white"
        />
      )}
    </div>
  );
};

export default TqPanelCard;
